import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navBgClass = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBgClass}`} id="navbar">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-book-open-line text-lg text-background-50"></i>
            </div>
            <span className={`font-heading text-xl font-bold transition-colors ${isHome && !scrolled ? 'text-white' : 'text-foreground-900'}`}>
              51漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${location.pathname === '/'
                ? isHome && !scrolled ? 'bg-white/20 text-white' : 'bg-primary-100 text-primary-700'
                : isHome && !scrolled ? 'text-white/80 hover:text-white hover:bg-white/10' : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'}`}
            >
              首页
            </Link>

            <div className="relative" onMouseEnter={() => setCategoryOpen(true)} onMouseLeave={() => setCategoryOpen(false)}>
              <button className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1 ${location.pathname.startsWith('/category')
                ? isHome && !scrolled ? 'bg-white/20 text-white' : 'bg-primary-100 text-primary-700'
                : isHome && !scrolled ? 'text-white/80 hover:text-white hover:bg-white/10' : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'}`}>
                分类
                <i className={`ri-arrow-down-s-line text-sm transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-1 bg-background-50 rounded-xl p-2 min-w-[200px] border border-background-200/70 shadow-sm">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="block px-4 py-2.5 rounded-lg text-sm text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/category/romance"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isHome && !scrolled ? 'text-white/80 hover:text-white hover:bg-white/10' : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'}`}
            >
              排行榜
            </Link>

            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${location.pathname === '/about'
                ? isHome && !scrolled ? 'bg-white/20 text-white' : 'bg-primary-100 text-primary-700'
                : isHome && !scrolled ? 'text-white/80 hover:text-white hover:bg-white/10' : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'}`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className={`w-48 px-4 py-2 rounded-full text-sm border transition-colors focus:outline-none ${isHome && !scrolled
                  ? 'bg-white/10 border-white/20 text-white placeholder-white/50 focus:border-white/40'
                  : 'bg-background-100 border-background-200/70 text-foreground-900 placeholder-foreground-400 focus:border-primary-300'}`}
              />
              <i className={`ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-sm ${isHome && !scrolled ? 'text-white/60' : 'text-foreground-400'}`}></i>
            </div>
            <Link
              to="/category/romance"
              className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${isHome && !scrolled ? 'text-white' : 'text-foreground-700'}`}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col gap-1">
            <Link to="/" onClick={() => setMobileOpen(false)} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors">首页</Link>
            <div className="px-4 py-3">
              <p className="text-sm font-medium text-foreground-500 mb-2">分类浏览</p>
              <div className="flex flex-wrap gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    onClick={() => setMobileOpen(false)}
                    className="px-3 py-1.5 rounded-full bg-background-100 text-xs text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link to="/about" onClick={() => setMobileOpen(false)} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors">关于我们</Link>
            <Link to="/category/romance" onClick={() => setMobileOpen(false)} className="mx-4 mt-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium text-center hover:bg-primary-600 transition-colors">开始阅读</Link>
          </div>
        </div>
      )}
    </nav>
  );
}